import Vue from 'vue'
import App from './App.vue'
import router from './router'

// GraphQL endpoint: https://u5erbirp2fejvil5xv4ajqbsa4.appsync-api.us-east-1.amazonaws.com/graphql
// GraphQL API KEY: da2-u3ziqkuqrzhepb252kixufs36m

import Amplify from 'aws-amplify';
import aws_exports from './aws-exports';
import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader';

Amplify.configure(aws_exports);
applyPolyfills().then(() => {
  defineCustomElements(window);
});

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
